export default "__VITE_ASSET__BeEf7oKi__"